/* eslint-disable max-lines-per-function */
import {DataObjectId} from './data-object'
import {Extension} from './extension'

const jsWithUrl = (url: string): string => /*javascript*/ `
var url = '${url}';

if (location.host === 'localhost:8001') {
  url = 'http://localhost:9001';
}

var eng = App.lang() === 'en';

function getEmailForColumn(col) {
  return App.httpPost(url + '/column/get', {id: col.id}).then(function (res) {
    return res.body;
  });
}

const extensionInColumnCache = {}
UIHandlers.onExtensionInColumn = function (column) {
  const cached = extensionInColumnCache[column.id]
  if (cached !== undefined) {
    return cached ? [{title: 'Интеграция с почтой'}] : []
  }

  getEmailForColumn(column).then(res => {
    extensionInColumnCache[column.id] = !!res.email
    Service.trigger(PlatformEvents.events.updateExtensionsInColumn)
  })

  return []
}

const intervalHandle = setInterval(() => {
  const boardId = Current.board?.id
  if (boardId) {
    const columns = Current.board.list()
    const configured = columns.some(c => extensionInColumnCache[c.id])
    if (configured) {
      App.analytics.sendExtensionUsage()
    }
  }
}, 5000)

Current.onBeforeScriptUnload = () => {
  clearInterval(intervalHandle)
}


function setCreateBy(col, createBy) {
  return App.httpPost(url + '/column/set-create-by', {id: col.id, createBy: createBy}).then(function (res) {
    return res.body;
  });
}

function setAssigned(col, assignee) {
  return App.httpPost(url + '/column/set-assignee', {id: col.id, assignee: assignee}).then(function (res) {
    return res.body;
  });
}

function createEmailForColumn(col) {
  return App.httpPost(url + '/column/create', {id: col.id}).then(function (res) {
    return res.body.email;
  });
}

function deleteEmailForColumn(col) {
  return App.httpPost(url + '/column/delete', {id: col.id});
}

var stillWaiting = false;
function openWaitPopup() {
  if (stillWaiting) {
    return;
  }
  stillWaiting = true;
  setTimeout(function () {
    if (!stillWaiting) {
      return;
    }
    stillWaiting = false;
    var wait = UI.text('...');
    wait.style = {
      minHeight: '260px'
    };
    UI.openPopup(eng ? 'E-mail integration' : 'Интеграция с почтой', wait);
  }, 300);
}

function openPopup(col) {
  openWaitPopup();
  getPopup(col).then(function (popup) {
    stillWaiting = false;
    UI.openPopup(eng ? 'E-mail integration' : 'Интеграция с почтой', popup);
  });
}

function getPopup(col) {
  return getEmailForColumn(col).then(function (res) {
    if (!res.result || res.result !== 'ok') {
      Notifier.error(eng ?
        'Can´t connect to the extension server' :
        'Не удалось подключиться к серверу расширения интеграции с почтой');
      return;
    }
    var email = res.email;
    var createBy = res.createBy;
    var assignee = res.assignee;
    var res = UI.panel();
    res.style = {
      minHeight: '260px'
    };
    if (email) {
      res.add(UI.text(eng ? 'E-mail address for column' : 'Адрес почты для колонки:'));

      var copyCnt = UI.panel();
      copyCnt.style = {
        display: 'flex',
        alignItems: 'center',
        marginTop: '8px'
      };
      res.add(copyCnt);

      var t = UI.text(email);
      t.style = {
        background: '#ebf0f3',
        padding: '4px 8px',
        display: 'block',
        borderRadius: '2px',
        boxShadow: 'inset 0 1px 6px -4px #000',
        border: '1px solid #bcbdcf',
        minWidth: '320px',
        color: '#3d4652'
      };
      t.onClick = function () {
        UI.selectText(t.getElement());
      };
      copyCnt.add(t);

      var clipboard = UI.text(eng ? 'Copy e-mail' : 'Копировать адрес', 'javascript:void(0)');
      clipboard.style = {
        color: '#2f97e6',
        cursor: 'pointer',
        marginLeft: '16px',
        paddingLeft: '28px',
        background: 'no-repeat url("/img/actions/copy.svg") 0 50% / 24px'
      };
      clipboard.onClick = function () {
        App.copyToClipboard(email).then(function () {
          Notifier.success(eng ? 'Copied successfully' : 'Скопировано');
        });
      };
      copyCnt.add(clipboard);

      var expl = UI.text(
        eng ? 'E-mails sent to this address will be added to this column as new tasks' :
        'Письма, отправленные на этот адрес, ' +
          'будут добавлены в колонку в виде задач'
      );
      expl.style = {
        marginTop: '8px',
        display: 'block'
      };
      res.add(expl);

      var del = UI.button(eng ? 'Remove e-mail' : 'Удалить e-mail');
      del.style = {marginTop: '16px'};
      del.onClick = function () {
        if (!confirm(eng
            ? 'Delete this e-mail address for the column?'
            : 'Удалить этот адрес колонки?')) {
          return;
        }
        openWaitPopup();
        deleteEmailForColumn(col).then(function () {
          openPopup(col);
        });
      };
      res.add(del);

      var delim = UI.panel();
      delim.style = {
        margin: '32px 0 16px',
        borderTop: '1px solid #bcbdcf'
      };
      res.add(delim);

      var assignedCnt = UI.panel();
      assignedCnt.style = {
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        height: '32px'
      };
      var assignedLabel = UI.text(eng
          ? 'Assign e-mail tasks to this user:'
          : 'Назначать задачи из почты на пользователя:');
      assignedLabel.style = {
        minWidth: '345px'
      };
      assignedCnt.add(assignedLabel);
      var chooseAssigned = UI.userSelect({
        chosen: assignee || [],
        size: 24,
        onChoose: function (value) {
          openWaitPopup();
          setAssigned(col, value).then(function () {
            openPopup(col);
          });
        }
      });
      assignedCnt.add(chooseAssigned);
      if (assignee && assignee.length > 0) {
        var delAssignee = UI.text(eng ? 'delete' : 'удалить');
        delAssignee.style = {
          color: '#2f97e6',
          cursor: 'pointer',
          marginLeft: '8px'
        };
        delAssignee.onClick = function () {
          openWaitPopup();
          setAssigned(col, undefined).then(function () {
            openPopup(col);
          });
        };
        assignedCnt.add(delAssignee);
      } else {
        var assignedBtnLabel = UI.text(eng ? 'Choose user' : 'Выбрать пользователя');
        assignedBtnLabel.style = {
          color: '#2f97e6',
          cursor: 'pointer',
          marginLeft: '8px'
        };
        var assignedBtn = UI.userSelect({
          chosen: assignee || [],
          size: 24,
          child: assignedBtnLabel,
          onChoose: function (value) {
            openWaitPopup();
            setAssigned(col, value).then(function () {
              openPopup(col);
            });
          }
        });
        assignedCnt.add(assignedBtn);
      }
      res.add(assignedCnt);

      var createByCnt = UI.panel();
      createByCnt.style = {
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        height: '32px'
      };
      var createdByLabel = UI.text(eng ? 'Set as task creator:' : 'Указывать автором задачи:');
      createdByLabel.style = {
        minWidth: '345px'
      };
      createByCnt.add(createdByLabel);
      var chooseCreateBy = UI.userSelect({
        chosen: createBy ? [createBy] : [],
        size: 24,
        onChoose: function (value) {
          openWaitPopup();
          setCreateBy(col, value[0]).then(function () {
            openPopup(col);
          });
        }
      });
      createByCnt.add(chooseCreateBy);
      if (!!createBy) {
        var delCreateBy = UI.text(eng ? 'delete' : 'удалить');
        delCreateBy.style = {
          color: '#2f97e6',
          cursor: 'pointer',
          marginLeft: '8px'
        };
        delCreateBy.onClick = function () {
          openWaitPopup();
          setCreateBy(col, undefined).then(function () {
            openPopup(col);
          });
        };
        createByCnt.add(delCreateBy);
      } else {
        var createdByBtnLabel = UI.text(eng ? 'Choose user' : 'Выбрать пользователя');
        createdByBtnLabel.style = {
          color: '#2f97e6',
          cursor: 'pointer',
          marginLeft: '8px'
        };
        var createdByBtn = UI.userSelect({
          chosen: assignee || [],
          size: 24,
          child: createdByBtnLabel,
          onChoose: function (value) {
            openWaitPopup();
            setCreateBy(col, value[0]).then(function () {
              openPopup(col);
            });
          }
        });
        createByCnt.add(createdByBtn);
      }
      res.add(createByCnt);
    } else {
      res.add(
        UI.text(
          eng
          ? [
            'Create new unique e-mail address.',
            'All e-mails sent to this address will be transformed',
            'to new tasks in this column.'
          ].join(' ')
          : [
            'Будет создан уникальный e-mail адрес.',
            'Все письма, которые будут на него попадать — ',
            'превратятся в задачу в колонке.',
          ].join(' ')
        )
      );

      var br = UI.panel();
      br.style = {margin: '16px 0'};
      res.add(br);

      var btnCnt = UI.panel();
      btnCnt.style = {
        margin: '32px 0',
        textAlign: 'center'
      };
      res.add(btnCnt);

      var br2 = UI.panel();
      br2.style = {margin: '16px 0'};
      res.add(br2);

      res.add(
        UI.text(
          eng
          ? [
            'Example: setup e-mail forwarding for important news',
            'about your competitors to created column e-mail address',
            'and get get these news as tasks on the board that you',
            'can later discuss with your colleagues.'
          ].join(' ')
          : [
            'Например: настройте пересылку важных новостей о ',
            'конкурентах на созданный e-mail адрес, получайте письма ',
            'в виде задач, обсуждайте с коллегами в маркетинге события на рынке.'
          ].join(' ')
        )
      );

      var btn = UI.button((eng ? 'Create column e-mail' : 'Создать адрес колонки') + ' “' + col.name + '”');
      btn.style = {
        padding: "6px 24px"
      };
      btn.onClick = function () {
        openWaitPopup();
        createEmailForColumn(col).then(function () {
          openPopup(col);
          Service.trigger(PlatformEvents.events.updateExtensionsInColumn)
        });

        App.analytics.send(
          'ExtensionMailSync:CreateEmailAddressToColumn'
        )
      };
      btnCnt.add(btn);
    }
    return res;
  });
}

UIHandlers.onColumnMenuShow = function (col) {
  if (col.isMirror() || col.isReport()) {
    return [];
  }
  var whoCanEdit = getWhoCanEdit();
  var canEdit = whoCanEdit === 'all' ||
    Current.user.isAdmin ||
    whoCanEdit === 'manager' && Current.user.getRole(col) === 'admin';
  if (!canEdit) {
    return [];
  }
  return [
    {
      title: eng ? 'E-mail integration' : 'Интеграция с почтой',
      onClick: function () {
        openPopup(col);
      },
    },
  ];
};

function getWhoCanEdit() {
  var data = Current.company.getData();
  return (data ? data.mailExtensionCanChange : undefined) || 'manager';
}
function setWhoCanEdit(value) {
  var data = Current.company.getData();
  data.mailExtensionCanChange = value;
  Current.company.setData(data);
}

var settings = UI.panel();
settings.style = {
  display: 'flex',
  alignItems: 'center'
};
var description = UI.text(eng
    ? 'Who can edit mail integration settings in board'
    : 'Кто может добавлять/изменять интеграцию с почтой в доске');
description.style = {
  lineHeight: 1.2,
  display: 'block',
  paddingRight: '24px'
};
settings.add(description);
var chooser = UI.rawHtml([
  '<select style="height: 32px">',
  '<option value="admin">', eng ? 'Admins' : 'Администраторы' ,'</option>',
  '<option value="manager">', eng ? 'Project managers' : 'Управляющие проектом' ,'</option>',
  '<option value="all">', eng ? 'All project users' : 'Все участники проекта' ,'</option>',
  '</select>'
].join(' '));
chooser.style = {
  marginTop: '8px',
  width: '320px'
};
settings.add(chooser);
settings.onRender = function () {
  var select = chooser.query('select')[0];
  select.value = getWhoCanEdit();
  select.addEventListener('change', function () {
    setWhoCanEdit(select.value);
  });
};
UI.components.extensionSettings.add(settings);
`

export const extensionMailSyncId = 'mail-sync'

// NOTE: in web & desktop images loads from webplatform (see extensions/mail-sync)
// in standalone images loads from /public/img/extensions/mail-sync/*
export const extensionMailSyncMedia = [
  'mail-sync_video-cover.jpg',
  'mail-sync_1.jpg',
  'mail-sync_2.jpg',
  'mail-sync_3.jpg',
  'mail-sync_4.jpg',
  'mail-sync_5.jpg'
]

// TODO: move this extension to /extensions (to webplatform),
// task: https://test-ru.yougile.com/team/e773f3991465/#ENT-443
export const extensionMailSync = (url: string): Extension => ({
  id: extensionMailSyncId,
  author: 'Yougile',
  ownerCompany: 'yougile' as DataObjectId,
  deleted: false,
  descriptionRu: `
    Письма с указанной почты будут появляться в колонке в виде задач.
    Настроить интеграцию можно в «Меню колонки» на доске`,
  descriptionEn: `
    Add e-mail address to any column in boards. Every e-mail sent to this address
    converts into a new task`,
  nameRu: 'Интеграция с почтой',
  nameEn: 'Mail sync',
  media: extensionMailSyncMedia,
  installs: {},
  ratings: {},
  dateReleased: '2024-10-01',
  tags: ['integrations'],
  keywords: ['почта', 'email'],
  versions: {
    // appVersion from start
    ['1.0.0']: {
      scripts: [
        {
          enabled: true,
          name: 'mail-sync.js',
          timestamp: 1606817296197,
          script: jsWithUrl(url)
        }
      ]
    }
  }
})
